import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../../LinkProvider";
import AnimatedCTA from "../AnimatedCTA";

function CTA() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="mt relative overflow-hidden">
      <div className="relative z-[1] glcontainer flex flex-col items-center text-center py-[80px] xl:py-[120px] gap-[40px]">
        <div className="flex flex-col gap-[20px] xl:gap-[30px] items-center">
          <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[38px] text-[#0A0A0A] tracking-[-0.92px] uppercase leading-none xl:max-w-[692px]">
            {t("about.cta.title")}
          </h2>
          <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4] xl:max-w-[643px]">
            {t("about.cta.desc")}
          </p>
        </div>
        <AnimatedCTA href={link} mobile>{t("about.banner.cta")}</AnimatedCTA>
      </div>
    </section>
  );
}

export default CTA;
